function initListsShow(): void {
  const sortSelect = document.getElementById("sort") as HTMLSelectElement | null;
  if (!sortSelect) return;

  sortSelect.addEventListener("change", () => {
    const form = sortSelect.closest("form");
    if (form) {
      form.submit();
    }
  });
}

document.addEventListener("turbo:load", initListsShow);
document.addEventListener("DOMContentLoaded", initListsShow);
